import { Modal } from 'antd';
import { useEffect } from 'react';
import { setConfirmModal } from '../store/utils';

const ConfirmProvider: React.FC = () => {
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    setConfirmModal(modal.confirm);
  }, []);

  return <>{contextHolder}</>;
};

export default ConfirmProvider;
